<template>
  <div class="home">
    <router-view />
    <PaymentModalSuccess :visible.sync="isPaymentSuccess" />
  </div>
</template>

<script>
import PaymentModalSuccess from '@/components/Users/Payment/PaymentModalSuccess'

export default {
  name: 'Home',
  components: { PaymentModalSuccess },
  data: () => ({
    isPaymentSuccess: false
  }),

  watch: {
    '$route.query.payment': 'paymentModalHandler'
  },

  methods: {
    paymentModalHandler(status) {
      this.isPaymentSuccess = status === 'success'
    }
  },

  mounted() {
    this.paymentModalHandler(this.$route.query.payment)
  }
}
</script>

<style scoped lang="scss">
.home {
  height: 100%;
}
</style>
